<template>
  <div>
    <h6 class="title">{{ translate.result.hello }}, {{ businessName }}</h6>

    <inelegible-result v-if="type === LEAD_RESULT_TYPE.INELEGIBLE_SALE" />

    <coverageless-result
      v-else-if="type === LEAD_RESULT_TYPE.COVERAGELESS_SALE"
      :supervisor="supervisor"
    />

    <manual-result
      v-else-if="type === LEAD_RESULT_TYPE.MANUAL_SALE"
      :resellers="resellers"
    />

    <direct-result v-else-if="type === LEAD_RESULT_TYPE.DIRECT_SALE" />

    <partner-result
      v-else-if="type === LEAD_RESULT_TYPE.PARTNER_SALE"
      :resellers="resellers"
    />

    <default-result v-else />

    <result-footer v-if="type !== LEAD_RESULT_TYPE.INELEGIBLE_SALE" />
  </div>
</template>

<script>
import { LEAD_RESULT_TYPE } from '@/constants/lead.js';
import InelegibleResult from './result/InelegibleResult.vue';
import CoveragelessResult from './result/CoveragelessResult.vue';
import ManualResult from './result/ManualResult.vue';
import DirectResult from './result/DirectResult.vue';
import PartnerResult from './result/PartnerResult.vue';
import DefaultResult from './result/DefaultResult.vue';
import ResultFooter from './result/ResultFooter.vue';

export default {
  name: 'message-result',
  props: {
    businessName: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: LEAD_RESULT_TYPE.DIRECT_SALE,
    },
  },
  components: {
    InelegibleResult,
    CoveragelessResult,
    ManualResult,
    DirectResult,
    PartnerResult,
    DefaultResult,
    ResultFooter,
  },
  data() {
    return {
      LEAD_RESULT_TYPE,
    };
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
    resellers() {
      return this.$store.getters.resellers;
    },
    supervisor() {
      return this.$store.getters.supervisor;
    },
  },
};
</script>
